/* ===========================================================================
   MAVELY REDESIGN  v1   (MV117)  —  the parts of the new design that need JS
   ===========================================================================
   Styling lives in mavely-redesign.v1.css. This file only adds what CSS
   cannot, and it never changes what an existing control does:

   1. DARK / LIGHT SWITCH — a pill switch (darkandligh.jpg) placed in front of
      "Français" in the top bar. It flips html[data-mv-theme] and remembers the
      choice in localStorage "mv_theme" (read back before the first paint by
      the one-line script at the top of index.html).

   2. EDIT YOUR DEALS IMAGE — a fifth tab after Network Live Leads, added to
      the tab strip the same way the Group/Page Score tab is (mavely-groupcalc):
      one more button in the strip, a body class while it is open, and a panel
      of its own. The panel holds the seven ON/OFF switches — the SAME
      .mv-imgopts block mavely-deals builds, moved here as-is with every
      listener still on it, so every script that reads or ticks those options
      keeps working (they all find it with document.querySelector) — and a
      Live Preview drawn by the site's own renderer, MavelyImg.composite, with
      exactly the options the eye buttons use.

   3. SMALL HELPERS for the stylesheet: which list is which (Deals List on the
      left, Your Selected Deals on the right, Manual Deals), which panel is
      Timer / Network, and the order + width of the tab buttons.

   4. DOWNLOAD ZIP in Your Selected Deals. mavely-zipdesign decides whether to
      build the designed ZIP by looking at the FIRST deal list on the page —
      which is now the Deals List on the left, not the list the button is in.
      For the button in Your Selected Deals the same test is made on its own
      list and, when it passes, zipdesign's own public entry point
      (__mvZipDesign().now) is called. zipdesign is not modified.

   Console: __mvRedesign()
   ========================================================================= */
(function () {
  'use strict';

  if (window.__mvRedesignLoaded) return;
  window.__mvRedesignLoaded = true;

  var DOC = document, HTML = DOC.documentElement;
  var THEME_KEY = 'mv_theme';
  var stats = { toggles: 0, moves: 0, renders: 0, renderErrors: 0, zips: 0, passes: 0 };

  /* ------------------------------------------------------------ strings */
  var T = {
    en: {
      imgTab: 'Edit your deals image',
      title: 'Edit Your Deals Image',
      sub: 'Switch each option on or off. Copied images, the ZIP and the preview below all use these settings.',
      live: 'Live preview',
      prev: 'Previous deal', next: 'Next deal', refresh: 'Refresh preview',
      wait: 'The image tools are loading…',
      none: 'No deal to preview yet. As soon as the Deals List shows a deal, its image appears here with your options.',
      fail: 'This deal could not be previewed. Try the next one.',
      loadingOpts: 'Loading the options…',
      dark: 'Dark mode', toLight: 'Switch to light mode', toDark: 'Switch to dark mode'
    },
    ar: {
      imgTab: 'تعديل صورة العروض',
      title: 'تعديل صورة عروضك',
      sub: 'فعّل أو أوقف كل خيار. الصور المنسوخة وملف ZIP والمعاينة أدناه تستخدم هذه الإعدادات.',
      live: 'معاينة مباشرة',
      prev: 'العرض السابق', next: 'العرض التالي', refresh: 'تحديث المعاينة',
      wait: 'جاري تحميل أدوات الصورة…',
      none: 'لا يوجد عرض للمعاينة بعد. عندما تظهر العروض في قائمة العروض ستظهر صورتها هنا بخياراتك.',
      fail: 'تعذرت معاينة هذا العرض. جرّب العرض التالي.',
      loadingOpts: 'جاري تحميل الخيارات…',
      dark: 'الوضع الداكن', toLight: 'التبديل إلى الوضع الفاتح', toDark: 'التبديل إلى الوضع الداكن'
    },
    es: {
      imgTab: 'Editar imagen de ofertas',
      title: 'Editar la imagen de tus ofertas',
      sub: 'Activa o desactiva cada opción. Las imágenes copiadas, el ZIP y la vista previa usan estos ajustes.',
      live: 'Vista previa',
      prev: 'Oferta anterior', next: 'Oferta siguiente', refresh: 'Actualizar vista previa',
      wait: 'Cargando las herramientas de imagen…',
      none: 'Aún no hay ofertas para previsualizar. Cuando la lista muestre una oferta, su imagen aparecerá aquí.',
      fail: 'No se pudo previsualizar esta oferta. Prueba con la siguiente.',
      loadingOpts: 'Cargando las opciones…',
      dark: 'Modo oscuro', toLight: 'Cambiar a modo claro', toDark: 'Cambiar a modo oscuro'
    },
    fr: {
      imgTab: 'Modifier l’image des offres',
      title: 'Modifier l’image de vos offres',
      sub: 'Activez ou désactivez chaque option. Les images copiées, le ZIP et l’aperçu utilisent ces réglages.',
      live: 'Aperçu en direct',
      prev: 'Offre précédente', next: 'Offre suivante', refresh: 'Actualiser l’aperçu',
      wait: 'Chargement des outils d’image…',
      none: 'Aucune offre à prévisualiser pour l’instant. Dès que la liste affiche une offre, son image apparaît ici.',
      fail: 'Impossible de prévisualiser cette offre. Essayez la suivante.',
      loadingOpts: 'Chargement des options…',
      dark: 'Mode sombre', toLight: 'Passer en mode clair', toDark: 'Passer en mode sombre'
    }
  };
  function lang() {
    var l = String(HTML.getAttribute('lang') || 'en').slice(0, 2).toLowerCase();
    return T[l] ? l : 'en';
  }
  function t(k) { return (T[lang()] && T[lang()][k]) || T.en[k] || k; }

  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  function el(tag, cls, text) {
    var n = DOC.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  var SVG_MOON =
    '<svg class="mv-rd-ico-moon" viewBox="0 0 26 22" aria-hidden="true" focusable="false">' +
    '<path fill="currentColor" d="M9.6 3.2a7.6 7.6 0 1 0 8.9 9.9 6 6 0 0 1-8.9-9.9z"/>' +
    '<path fill="currentColor" d="M17.6 2.2l.55 1.4 1.45.1-1.12.93.36 1.42-1.24-.78-1.24.78.36-1.42-1.12-.93 1.45-.1z"/>' +
    '<path fill="currentColor" d="M22.2 7.1l.38.95.98.07-.76.63.25.96-.85-.53-.84.53.24-.96-.75-.63.98-.07z"/>' +
    '<path fill="currentColor" d="M20.2 12.4l.33.83.86.06-.66.55.21.84-.74-.46-.73.46.21-.84-.66-.55.86-.06z"/>' +
    '</svg>';
  var SVG_SUN =
    '<svg class="mv-rd-ico-sun" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<circle cx="12" cy="12" r="4.6" fill="currentColor"/>' +
    '<g stroke="currentColor" stroke-width="2.2" stroke-linecap="round">' +
    '<path d="M12 1.8v2.6M12 19.6v2.6M1.8 12h2.6M19.6 12h2.6M4.8 4.8l1.8 1.8M17.4 17.4l1.8 1.8M4.8 19.2l1.8-1.8M17.4 6.6l1.8-1.8"/></g></svg>';
  var SVG_IMG =
    '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<rect x="3" y="3" width="18" height="18" rx="3"/><circle cx="9" cy="9" r="2"/><path d="m21 15-4.2-4.2a2 2 0 0 0-2.8 0L5 20"/></svg>';
  var SVG_LEFT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>';
  var SVG_RIGHT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg>';
  var SVG_REFRESH = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12a9 9 0 1 1-2.64-6.36"/><path d="M21 3v6h-6"/></svg>';

  /* =======================================================================
     1. DARK / LIGHT
     ======================================================================= */
  function theme() { return HTML.getAttribute('data-mv-theme') === 'light' ? 'light' : 'dark'; }

  function paintMeta() {
    var m = DOC.querySelector('meta[name="theme-color"]');
    if (m) m.setAttribute('content', theme() === 'light' ? '#ffffff' : '#0f141c');
  }

  var toggle = null;
  function buildToggle() {
    var b = el('button', 'mv-rd-theme');
    b.type = 'button';
    b.setAttribute('role', 'switch');
    b.setAttribute('data-no-i18n', '1');
    b.innerHTML = '<span class="mv-rd-theme-track" aria-hidden="true">' + SVG_MOON + SVG_SUN +
                  '<span class="mv-rd-theme-knob"></span></span>';
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      setTheme(theme() === 'light' ? 'dark' : 'light');
    });
    return b;
  }
  function paintToggle() {
    if (!toggle) return;
    var dark = theme() === 'dark';
    toggle.setAttribute('aria-checked', dark ? 'true' : 'false');
    toggle.setAttribute('aria-label', t('dark'));
    toggle.title = dark ? t('toLight') : t('toDark');
  }
  function setTheme(v) {
    /* No colour transitions for the one frame of the swap: dozens of elements
       carry transition-all, and fading each of them separately looks like the
       page is repainting in pieces. The switch keeps its own animation. */
    HTML.classList.add('mv-rd-swap');
    HTML.setAttribute('data-mv-theme', v === 'light' ? 'light' : 'dark');
    lsSet(THEME_KEY, v === 'light' ? 'light' : 'dark');
    stats.toggles++;
    paintMeta();
    paintToggle();
    var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };
    raf(function () { raf(function () { HTML.classList.remove('mv-rd-swap'); }); });
    schedulePreview(60);
  }
  /** In front of "Français", as asked. Before i18n has added Français the
      switch waits at the end of the group and is moved when it appears. */
  function placeToggle() {
    var box = DOC.querySelector('.mv-rd-langs');
    if (!box) return;
    if (!toggle) toggle = buildToggle();
    var fr = box.querySelector('[data-mv-lang="fr"]');
    if (fr) {
      if (toggle.parentNode !== box || toggle.nextSibling !== fr) box.insertBefore(toggle, fr);
    } else if (toggle.parentNode !== box) {
      box.appendChild(toggle);
    }
    paintToggle();
  }

  /* =======================================================================
     2. TABS: order, width, and the Edit Your Deals Image tab
     ======================================================================= */
  var ORDER = ['timer', 'deals', 'group', 'leads', 'img', 'manual'];

  function tabId(b) {
    if (b.classList.contains('mv-rd-imgtab')) return 'img';
    if (b.getAttribute('data-mv-tab') === 'group' || b.classList.contains('mv-gc-tab')) return 'group';
    return b.getAttribute('data-mv-rd-tab') || '';
  }

  function isImgOpen() { return DOC.body.classList.contains('mv-rd-img-active'); }

  function buildImgTab() {
    var b = el('button', 'mv-rd-imgtab');
    b.type = 'button';
    b.setAttribute('role', 'tab');
    b.setAttribute('data-no-i18n', '1');
    b.setAttribute('aria-selected', isImgOpen() ? 'true' : 'false');
    b.innerHTML = SVG_IMG;
    var s = el('span', 'truncate', t('imgTab'));
    b.appendChild(s);
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      openImg(true);
    });
    return b;
  }

  function tagStrip() {
    var s = DOC.querySelector('.mv-rd-strip');
    if (!s) return;
    /* React renders its four buttons in a fixed order: Timer USA, Deals List
       (now Your Selected Deals), Manual Deals, Network Live Leads. */
    var react = [], i, b;
    for (i = 0; i < s.children.length; i++) {
      b = s.children[i];
      if (b.tagName !== 'BUTTON') continue;
      if (b.classList.contains('mv-rd-imgtab') || b.classList.contains('mv-gc-tab') ||
          b.getAttribute('data-mv-tab') === 'group') continue;
      react.push(b);
    }
    var ids = ['timer', 'deals', 'manual', 'leads'];
    for (i = 0; i < react.length && i < 4; i++) {
      if (react[i].getAttribute('data-mv-rd-tab') !== ids[i]) react[i].setAttribute('data-mv-rd-tab', ids[i]);
    }

    var mine = s.querySelector('.mv-rd-imgtab');
    if (!mine) { mine = buildImgTab(); s.appendChild(mine); }
    var lab = mine.querySelector('.truncate');
    if (lab && lab.textContent !== t('imgTab')) lab.textContent = t('imgTab');
    mine.title = t('title');

    /* Widths: two rows, every row filled edge to edge. */
    var vis = [];
    for (i = 0; i < s.children.length; i++) {
      b = s.children[i];
      if (b.tagName !== 'BUTTON') continue;
      var id = tabId(b);
      if (window.getComputedStyle(b).display === 'none') continue;
      vis.push({ b: b, o: ORDER.indexOf(id) === -1 ? 9 : ORDER.indexOf(id) });
    }
    vis.sort(function (a, c) { return a.o - c.o; });
    var n = vis.length, spans = [];
    if (n >= 6) { for (i = 0; i < n; i++) spans.push(2); }
    else if (n === 5) spans = [2, 2, 2, 3, 3];
    else if (n === 4) spans = [3, 3, 3, 3];
    else for (i = 0; i < n; i++) spans.push(n ? Math.max(2, Math.floor(6 / n)) : 6);
    for (i = 0; i < n; i++) {
      var want = 'span ' + spans[i];
      if (vis[i].b.style.gridColumn !== want) vis[i].b.style.gridColumn = want;
      if (vis[i].b.style.order !== String(i + 1)) vis[i].b.style.order = String(i + 1);
    }
    if (s.getAttribute('data-mv-rd-n') !== String(n)) s.setAttribute('data-mv-rd-n', String(n));
  }

  function openImg(on) {
    var body = DOC.body;
    if (on) {
      body.classList.add('mv-rd-img-active');
      /* the same thing mavely-groupcalc does when any other tab is clicked */
      body.classList.remove('mv-gc-active');
      var g = DOC.querySelector('[data-mv-tab="group"]');
      if (g) g.setAttribute('aria-selected', 'false');
      ensurePanel();
      moveOptions();
      schedulePreview(0);
    } else {
      body.classList.remove('mv-rd-img-active');
    }
    var mine = DOC.querySelector('.mv-rd-imgtab');
    if (mine) mine.setAttribute('aria-selected', on ? 'true' : 'false');
  }

  /* Any other tab in the strip hands the panel back — captured before the
     tab's own handler, like mavely-groupcalc does. */
  DOC.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('button') : null;
    if (!b || b.classList.contains('mv-rd-imgtab')) return;
    var p = b.parentElement;
    if (p && p.classList && p.classList.contains('mv-rd-strip') && isImgOpen()) openImg(false);
  }, true);

  /* =======================================================================
     THE PANEL
     ======================================================================= */
  var panel = null, stage = null, stageImg = null, stageMsg = null, nameEl = null;

  function buildPanel() {
    var p = el('div', 'mv-rd-imgpanel');
    p.setAttribute('role', 'tabpanel');

    var head = el('div', 'mv-rd-ip-head');
    var h = el('h3', 'mv-rd-ip-title', t('title'));
    h.setAttribute('data-no-i18n', '1');
    var sub = el('p', 'mv-rd-ip-sub', t('sub'));
    sub.setAttribute('data-no-i18n', '1');
    head.appendChild(h);
    head.appendChild(sub);

    var opts = el('div', 'mv-rd-ip-opts');
    var wait = el('div', 'mv-rd-ip-empty', t('loadingOpts'));
    wait.setAttribute('data-no-i18n', '1');
    opts.appendChild(wait);

    var prev = el('div', 'mv-rd-ip-prev');
    var bar = el('div', 'mv-rd-ip-bar');
    var h4 = el('h4');
    h4.setAttribute('data-no-i18n', '1');
    h4.appendChild(el('i'));
    h4.appendChild(el('span', 'mv-rd-ip-live', t('live')));
    nameEl = el('span', 'mv-rd-ip-name');
    nameEl.setAttribute('data-no-i18n', '1');
    bar.appendChild(h4);
    bar.appendChild(nameEl);
    [['prev', SVG_LEFT], ['next', SVG_RIGHT], ['refresh', SVG_REFRESH]].forEach(function (a) {
      var btn = el('button', 'mv-rd-ip-btn');
      btn.type = 'button';
      btn.setAttribute('data-act', a[0]);
      btn.setAttribute('data-no-i18n', '1');
      btn.title = t(a[0]);
      btn.setAttribute('aria-label', t(a[0]));
      btn.innerHTML = a[1];
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (a[0] === 'prev') pick--;
        if (a[0] === 'next') pick++;
        schedulePreview(0, true);
      });
      bar.appendChild(btn);
    });

    stage = el('div', 'mv-rd-ip-stage');
    stageImg = el('img');
    stageImg.alt = '';
    /* eager: a lazy <img> that is not on screen yet never loads, and the
       site's perf script makes every image without the attribute lazy */
    stageImg.setAttribute('loading', 'eager');
    stageImg.style.display = 'none';
    stageMsg = el('div', 'mv-rd-ip-msg', t('wait'));
    stageMsg.setAttribute('data-no-i18n', '1');
    stage.appendChild(stageImg);
    stage.appendChild(stageMsg);

    prev.appendChild(bar);
    prev.appendChild(stage);

    p.appendChild(head);
    p.appendChild(opts);
    p.appendChild(prev);

    /* Any change to a switch, a colour, the watermark text or a slider is a
       change to the picture. */
    p.addEventListener('change', function () { schedulePreview(180); }, false);
    p.addEventListener('input', function () { schedulePreview(260); }, false);
    return p;
  }

  function relabelPanel() {
    if (!panel) return;
    var q = function (s) { return panel.querySelector(s); };
    if (q('.mv-rd-ip-title')) q('.mv-rd-ip-title').textContent = t('title');
    if (q('.mv-rd-ip-sub')) q('.mv-rd-ip-sub').textContent = t('sub');
    if (q('.mv-rd-ip-live')) q('.mv-rd-ip-live').textContent = t('live');
    if (q('.mv-rd-ip-empty')) q('.mv-rd-ip-empty').textContent = t('loadingOpts');
    var bs = panel.querySelectorAll('.mv-rd-ip-btn');
    for (var i = 0; i < bs.length; i++) {
      var k = bs[i].getAttribute('data-act');
      bs[i].title = t(k);
      bs[i].setAttribute('aria-label', t(k));
    }
  }

  function ensurePanel() {
    var right = DOC.querySelector('.mv-rd-right');
    if (!right) return null;
    if (!panel) panel = buildPanel();
    if (panel.parentNode !== right) right.appendChild(panel);
    return panel;
  }

  /* The option block is built by mavely-deals inside the Deals List and then
     filled by the image, link-comments, watermark and frame scripts, all of
     which find it with document.querySelector('.mv-imgopts …'). Moving the
     element keeps every listener on it. If the Deals List is ever mounted
     again, mavely-deals builds a fresh block there; that one is moved in and
     the old copy is dropped, so there is never more than one. */
  function moveOptions() {
    var all = DOC.querySelectorAll('.mv-imgopts');
    if (!all.length) return;
    var p = ensurePanel();
    if (!p) return;
    var host = p.querySelector('.mv-rd-ip-opts');
    var fresh = null, i;
    for (i = 0; i < all.length; i++) if (!host.contains(all[i])) fresh = all[i];
    if (!fresh) return;
    var old = host.querySelectorAll('.mv-imgopts');
    for (i = 0; i < old.length; i++) if (old[i].parentNode) old[i].parentNode.removeChild(old[i]);
    var wait = host.querySelector('.mv-rd-ip-empty');
    if (wait) wait.parentNode.removeChild(wait);
    host.insertBefore(fresh, host.firstChild);
    stats.moves++;
    schedulePreview(120);
  }

  /* =======================================================================
     LIVE PREVIEW — MavelyImg.composite, with the eye buttons' options
     ======================================================================= */
  var pick = 0, token = 0, previewTimer = null, lastUrl = '', lastSig = '', lastDealKey = '';

  function optOn(k) { return lsGet(k) === '1'; }

  function previewOpts() {
    var MI = window.MavelyImg || {};
    var F = null;
    try { F = typeof window.__mvFrames === 'function' ? window.__mvFrames() : null; } catch (e) { F = null; }
    return {
      logo: typeof MI.logo === 'function' ? !!MI.logo() : optOn('mv_img_logo'),
      price: typeof MI.price === 'function' ? !!MI.price() : optOn('mv_img_price'),
      linkComments: optOn('mv_img_linkcomments'),
      frame: F ? !!F.on : optOn('mv_frame_on')
    };
  }

  /** The cards to preview: Your Selected Deals first, then the Deals List. */
  function cardImages() {
    var out = [], seen = {};
    var sets = [
      DOC.querySelectorAll('.mv-rd-yours img[alt="Deal product"]'),
      DOC.querySelectorAll('.mv-rd-left img[alt="Deal product"]')
    ];
    for (var s = 0; s < sets.length; s++) {
      for (var i = 0; i < sets[s].length; i++) {
        var src = sets[s][i].getAttribute('src') || '';
        if (!src || /default\.jpg/.test(src) || seen[src]) continue;
        seen[src] = true;
        out.push(sets[s][i]);
      }
    }
    return out;
  }

  function sameOrigin(u) {
    try {
      var x = new URL(u, window.location.href);
      return x.origin === window.location.origin ? x.pathname + x.search : u;
    } catch (e) { return u; }
  }

  /** The deal record behind a card, found the way the eye preview finds it
      (MavelyDealsIndex, from mavely-deals); anything missing is read off the
      card itself. */
  function dealFor(img) {
    var card = img, found = null, i;
    for (i = 0; i < 6 && card && !found; i++) {
      card = card.parentElement;
      if (!card) break;
      var txt = String(card.textContent || '').replace(/\s+/g, ' ').trim();
      if (txt.length < 12 || typeof window.MavelyDealsIndex !== 'function') continue;
      try { found = window.MavelyDealsIndex(txt.slice(0, 90).replace(/[.…]+\s*$/, '')); } catch (e) { found = null; }
    }
    var d = {};
    if (found) for (var k in found) if (Object.prototype.hasOwnProperty.call(found, k)) d[k] = found[k];
    d.image_path = sameOrigin(d.image_path || img.getAttribute('src') || '');
    var box = img.parentElement;
    var row = box;
    for (i = 0; i < 4 && row && !row.querySelector('p'); i++) row = row.parentElement;
    if (!d.description) {
      var p = row && row.querySelector('p');
      d.description = p ? p.textContent : '';
    }
    if (box) {
      var now = box.querySelector('.mv-price-now'), was = box.querySelector('.mv-price-was'), off = box.querySelector('.mv-badge-off');
      if (!d.price && now) d.price = now.textContent.trim();
      if (!d.old_price && was) d.old_price = was.textContent.trim();
      if (!d.discount && off) d.discount = off.textContent.trim();
    }
    if (!d.store) {
      var u = String(d.url || d.comment_link || d.image_path || '').toLowerCase();
      ['walmart', 'amazon', 'aliexpress', 'ebay', 'etsy', 'target'].forEach(function (s) {
        if (!d.store && u.indexOf(s) !== -1) d.store = s;
      });
    }
    return d;
  }

  function showMsg(text) {
    if (!stage) return;
    stage.classList.remove('is-busy');
    stageMsg.textContent = text;
    stageMsg.style.display = '';
    stageImg.style.display = 'none';
    if (nameEl) nameEl.textContent = '';
  }

  function schedulePreview(delay, force) {
    if (force) lastSig = '';
    if (previewTimer) window.clearTimeout(previewTimer);
    previewTimer = window.setTimeout(function () { previewTimer = null; renderPreview(); }, delay || 0);
  }

  function renderPreview() {
    if (!panel || !isImgOpen()) return;
    var MI = window.MavelyImg;
    if (!MI || typeof MI.composite !== 'function') { showMsg(t('wait')); schedulePreview(900); return; }
    var imgs = cardImages();
    if (!imgs.length) { showMsg(t('none')); return; }
    pick = ((pick % imgs.length) + imgs.length) % imgs.length;
    var img = imgs[pick];
    var deal = dealFor(img);
    var o = previewOpts();
    var btns = panel.querySelectorAll('.mv-rd-ip-btn[data-act="prev"], .mv-rd-ip-btn[data-act="next"]');
    for (var b = 0; b < btns.length; b++) btns[b].disabled = imgs.length < 2;
    if (nameEl) nameEl.textContent = (pick + 1) + '/' + imgs.length + ' · ' +
      String(deal.description || '').split('\n')[0].slice(0, 80);

    var my = ++token;
    stage.classList.add('is-busy');
    var p;
    try { p = Promise.resolve(MI.composite(deal, o)); } catch (e) { p = Promise.reject(e); }
    p.then(function (blob) {
      if (my !== token) return;
      if (!blob || !blob.size) throw new Error('empty');
      var u = URL.createObjectURL(blob);
      /* decoded off-screen first, then swapped in, so the picture never
         blinks and the previous one stays until the new one is ready */
      var probe = new Image();
      probe.onload = function () {
        if (my !== token) { URL.revokeObjectURL(u); return; }
        stageImg.src = u;
        stage.classList.remove('is-busy');
        stageImg.style.display = '';
        stageMsg.style.display = 'none';
        if (lastUrl && lastUrl !== u) { try { URL.revokeObjectURL(lastUrl); } catch (e) {} }
        lastUrl = u;
        stats.renders++;
      };
      probe.onerror = function () { if (my === token) showMsg(t('fail')); URL.revokeObjectURL(u); };
      probe.src = u;
    }).catch(function () {
      if (my !== token) return;
      stats.renderErrors++;
      showMsg(t('fail'));
    });
  }

  /* The frame designer and the colour pickers save to localStorage and close
     their own windows; their changes are picked up from a signature of those
     settings, checked only while this tab is open. */
  var NOISE = /^(mv_optrow_h_|mv_deals_hold|mv_device_id|mv_sd_|mv_theme|mv_tab_hide_|mv_real_images|mv_work_mode|mv_opt_hide_)/;
  function settingsSig() {
    var parts = [];
    try {
      var ls = window.localStorage;
      for (var i = 0; i < ls.length; i++) {
        var k = ls.key(i);
        if (!k || k.indexOf('mv_') !== 0 || NOISE.test(k)) continue;
        var v = ls.getItem(k) || '';
        parts.push(k + '=' + (v.length > 200 ? v.length + ':' + v.slice(0, 60) + v.slice(-60) : v));
      }
    } catch (e) {}
    parts.sort();
    return parts.join('|');
  }
  window.setInterval(function () {
    if (!panel || !isImgOpen() || DOC.hidden) return;
    var sig = settingsSig();
    var imgs = cardImages();
    var dealKey = imgs.length ? (imgs[((pick % imgs.length) + imgs.length) % imgs.length].getAttribute('src') || '') : '';
    if (sig !== lastSig || dealKey !== lastDealKey) {
      var first = lastSig === '';
      lastSig = sig;
      lastDealKey = dealKey;
      if (!first) schedulePreview(0);
    }
  }, 1200);

  /* =======================================================================
     3. WHICH LIST / PANEL IS WHICH
     ======================================================================= */
  function add(n, c) { if (!n.classList.contains(c)) n.classList.add(c); }

  function hasElements(recs) {
    for (var i = 0; i < recs.length; i++) {
      var r = recs[i], j;
      if (r.type !== 'childList') continue;
      for (j = 0; j < r.addedNodes.length; j++) if (r.addedNodes[j].nodeType === 1) return true;
      for (j = 0; j < r.removedNodes.length; j++) if (r.removedNodes[j].nodeType === 1) return true;
    }
    return false;
  }

  function markPanels() {
    var roots = DOC.querySelectorAll('.mv-rd-left-in > div, .mv-rd-rpanel > div');
    for (var i = 0; i < roots.length; i++) {
      var r = roots[i];
      var cls = String(r.className || '');
      if (r.classList.contains('mv-rd-left-load')) continue;
      if (cls.indexOf('bg-[#0b132b]') !== -1 && r.querySelector('h2')) {
        add(r, 'mv-rd-dl');
        if (r.parentElement && r.parentElement.classList.contains('mv-rd-left-in')) add(r, 'mv-rd-dl-a');
        else if (r.querySelector('[class*="max-h-[440px]"]')) add(r, 'mv-rd-yours');
        else add(r, 'mv-rd-manual');
      } else if (cls.indexOf('bg-[#1a1145]') !== -1) {
        add(r, 'mv-rd-leads');
      } else if (cls.indexOf('h-[580px]') !== -1 || r.querySelector('img[alt="USA Flag"]')) {
        add(r, 'mv-rd-timer');
      }
    }
  }

  /* =======================================================================
     4. DOWNLOAD ZIP inside Your Selected Deals
     ======================================================================= */
  window.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('button') : null;
    if (!b || b.disabled) return;
    var row = b.parentElement;
    var root = b.closest ? b.closest('.mv-rd-yours') : null;
    if (!root || !row || row.parentElement !== root || String(row.className).indexOf('bg-black/20') === -1) return;
    var Z = window.__mvZipDesign;
    if (typeof Z !== 'function' || !window.MavelyImg || typeof window.MavelyImg.composite !== 'function') return;
    var z;
    try { z = Z(); } catch (x) { return; }
    if (!z || !z.ready || typeof z.now !== 'function') return;
    var sc = root.querySelector('[class*="max-h-[440px]"]');
    /* the same test zipdesign makes — on THIS list. Nothing shortened here:
       the app's own "Shorten Link Required First!" dialog opens, as before. */
    if (!sc || !/new shorten link/i.test(sc.textContent || '')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (!z.busy) { z.now(); stats.zips++; }
  }, true);

  /* =======================================================================
     5. A DEAL DELETED IN ONE LIST LEAVES THE OTHER ONE TOO
     =======================================================================
     Both lists are on screen together now. The red button already deletes
     the deal for this visitor everywhere (mavely-dealsflow v2 marks it
     deleted in every list it holds), and the list it was pressed in drops the
     card at once. The OTHER list only learns about it on its next read — which
     used to be the moment MY SELECTED DEALS was ticked or unticked. So once
     the card has left the list it was deleted from (i.e. the server said yes),
     both lists are asked to re-read through dealsflow's own public refresh,
     answered from memory with the deleted deal already taken out. */
  function refreshLists() {
    try {
      if (window.MavelyDealsFlow && typeof window.MavelyDealsFlow.refresh === 'function') window.MavelyDealsFlow.refresh();
      else window.dispatchEvent(new Event('sh_link_shortened'));
      stats.syncs = (stats.syncs || 0) + 1;
    } catch (e) {}
  }
  DOC.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('button') : null;
    if (!b || String(b.className).indexOf('bg-rose-600') === -1) return;
    var root = b.closest('.mv-rd-dl');
    var row = b.parentElement;
    var img = row && row.querySelector ? row.querySelector('img[alt="Deal product"]') : null;
    if (!root || !img) return;
    var src = img.getAttribute('src') || '';
    var tries = 0;
    var iv = window.setInterval(function () {
      tries++;
      var imgs = root.querySelectorAll('img[alt="Deal product"]'), still = false;
      for (var i = 0; i < imgs.length; i++) if (imgs[i].getAttribute('src') === src) { still = true; break; }
      if (!still) { window.clearInterval(iv); refreshLists(); }
      else if (tries > 50) window.clearInterval(iv);          // refused: nothing to follow
    }, 150);
  }, true);

  /* =======================================================================
     THE PASS — cheap, coalesced to one per frame
     ======================================================================= */
  var queued = false;
  function pass() {
    queued = false;
    stats.passes++;
    try { placeToggle(); } catch (e) {}
    try { tagStrip(); } catch (e) {}
    try { markPanels(); } catch (e) {}
    try { if (DOC.querySelector('.mv-imgopts')) moveOptions(); } catch (e) {}
    try { if (isImgOpen()) ensurePanel(); } catch (e) {}
  }
  function schedule() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || window.setTimeout)(pass);
  }

  var lastLang = lang();
  function onLang() {
    var l = lang();
    if (l === lastLang) return;
    lastLang = l;
    paintToggle();
    relabelPanel();
    tagStrip();
    schedulePreview(0);
  }

  function start() {
    paintMeta();
    pass();
    try {
      /* Only elements coming or going matter here. Text changes are
         ignored on purpose: some labels on the page are rewritten every
         frame by their own scripts, and reacting to those would cost a
         pass per frame for nothing. The lists are marked in the same
         microtask as the mutation, i.e. before the browser paints. */
      new MutationObserver(function (recs) {
        if (!hasElements(recs)) return;
        markPanels();
        schedule();
      }).observe(DOC.body, { childList: true, subtree: true });
      new MutationObserver(onLang).observe(HTML, { attributes: true, attributeFilter: ['lang'] });
    } catch (e) {
      window.setInterval(pass, 700);
    }
    /* Tab visibility can change without a node being added (the hide-tabs
       setting, a late stylesheet), so the strip is re-measured now and then. */
    window.setInterval(function () { try { tagStrip(); } catch (e) {} }, 2000);
    window.addEventListener('storage', function (e) {
      if (e.key === THEME_KEY && e.newValue) {
        HTML.setAttribute('data-mv-theme', e.newValue === 'light' ? 'light' : 'dark');
        paintMeta(); paintToggle();
      }
    });
  }

  if (DOC.readyState === 'loading') DOC.addEventListener('DOMContentLoaded', start);
  else start();

  window.MavelyRedesign = {
    theme: theme, setTheme: setTheme, openImageTab: function () { openImg(true); },
    preview: function () { schedulePreview(0, true); }
  };
  window.__mvRedesign = function () {
    var imgs = cardImages();
    return {
      version: 'v1 (MV117)',
      theme: theme(),
      toggleIn: !!(toggle && toggle.parentNode),
      toggleBeforeFr: !!(toggle && toggle.nextSibling && toggle.nextSibling.getAttribute &&
                         toggle.nextSibling.getAttribute('data-mv-lang') === 'fr'),
      imageTab: !!DOC.querySelector('.mv-rd-imgtab'),
      imageTabOpen: isImgOpen(),
      optionsInPanel: !!(panel && panel.querySelector('.mv-imgopts')),
      optionBlocks: DOC.querySelectorAll('.mv-imgopts').length,
      lists: {
        left: !!DOC.querySelector('.mv-rd-dl-a'),
        yours: !!DOC.querySelector('.mv-rd-yours'),
        manual: !!DOC.querySelector('.mv-rd-manual')
      },
      previewDeals: imgs.length,
      stats: stats
    };
  };

  if (window.console && console.info) {
    console.info('[mavely-redesign] v1 ready — 3-column layout, Dark/Light, Edit Your Deals Image');
  }
})();
